import '../app.es6';
import angular from 'angular';

class ConfirmAction {
  /* @ngInject */
  constructor (Resource, $sessionStorage, $window) {
    this.Resource = Resource;
    this.$sessionStorage = $sessionStorage;
    this.$window = $window;
    this.errorMsg = '保存されていない項目があります。\n 移動してもよろしいですか？';

    ConfirmAction.$inject = ['Resource', '$sessionStorage', '$window'];
  }

  // Confirmを出力：キャンセル => False , OK => True
  // Confirmを出力しない：True
  confirm (e) {
    e = e || null;
    // 編集中フラグ = OFF または Confirm = OK
    if (!this.$sessionStorage.editStatus || this.$window.confirm(this.errorMsg)) {
      this.$sessionStorage.editStatus = false;
      return true;
    }
    if (e) {
      e.preventDefault();
    }
    return false;
  }
}

angular.module('myApp').service('ConfirmAction', ConfirmAction);



// WEBPACK FOOTER //
// ./app/services/confirm-action.es6